export default __webpack_public_path__ + "static/media/faq.ecc3ddf1.png";